import React from 'react';

const Input = ({ label, id, error, className = '', ...props }) => {
  return (
    <div className={`mb-4 ${className}`}>
      {label && (
        <label htmlFor={id} className="block text-sm font-medium text-brand-text mb-1">
          {label}
        </label>
      )}
      <input
        id={id}
        className={`w-full px-3 py-2 border rounded-lg focus:outline-none focus:ring-2 focus:ring-brand-primary/50 transition-colors
          ${error ? 'border-brand-alert' : 'border-gray-300'}
          bg-white text-brand-dark`}
        {...props}
      />
      {error && <p className="mt-1 text-xs text-brand-alert">{error}</p>}
    </div>
  );
};

export default Input;